import * as Sentry from '@sentry/gatsby';

Sentry.init({
    dsn: "https://db77fdbe3b174d268a56eb855f55a044@o1221731.ingest.sentry.io/6569403",
    sampleRate: 1.0,
});
